import type { UserClaims } from '@okta/okta-auth-js';

export function getUserDisplayName(user: UserClaims | null, fallback = 'Utente'): string {
  if (!user) return fallback;
  return user.name ?? user.preferred_username ?? user.email ?? fallback;
}

export function getUserEmail(user: UserClaims | null): string | null {
  return user?.email ?? user?.preferred_username ?? null;
}

export function getUserInitials(user: UserClaims | null, fallback = 'TU'): string {
  if (!user) return fallback;

  const name = getUserDisplayName(user, '');
  if (!name) return fallback;

  if (name.includes(' ')) {
    const words = name.trim().split(' ').filter((word) => word.length > 0);
    if (words.length >= 2) {
      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
  }

  return name.substring(0, 2).toUpperCase() || fallback;
}
